import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { ArrowDownIcon } from '../icons/arrow-down-icon';
import withTranslate from '../../hoc/with-translate';
import styles from './member-sort-field-mobile.scss';

const classNames = require('classnames');

const MembersSortFieldMobile = ({ className, value, onChange, sorts, t }) => (
  <div
    className={classNames(styles.container, className, 'ma-all-members-header-border', 'ma-font-body-m')}
    data-hook="am-sort-field"
  >
    <span className={styles.sort}>{t('member-sort.text')}</span>
    <ArrowDownIcon className="ma-members-list-icon-color" />
    <select className={styles.select} value={value} onChange={(e) => onChange(e.target.value)}>
      {_.map(sorts, (translation, v) => (
        <option key={v} value={v}>
          {t(translation)}
        </option>
      ))}
    </select>
  </div>
);

MembersSortFieldMobile.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  sorts: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslate(MembersSortFieldMobile);
